@let reportHtml = reportHtml$ | async;
@if (reportHtml) {
  <div>
    <a [href]="parametrizationUrl">AI Profile Segmentation</a>
    <div #reportContainer [innerHTML]="reportHtml | safeHtml"></div>
  </div>
}
